import { HeaderReview } from './header-review';
import { IStepControl, Step } from '../../../domains/wizard';
import { AddressReview } from './address-review';
import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

interface IProps {
  stepControl: IStepControl;
}

export const ServiceAddressReview = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  return (
    <div className="avoid-break">
      <div className="container-grey m-bottom-30">
        <HeaderReview stepControl={props.stepControl} step={Step.Service} />
        <span className="header-text-grey">{t('TAXES_WILL_BE_DETERMINED_BASED_ON_THIS_ADDRESS')}</span>
        <AddressReview addressType={'service'} />
      </div>
    </div>
  );
});
